import { useContext, useState } from "react";

import PermissionContext from "./PermissionContext";

const usePermission = (permission) => {
  return useContext(PermissionContext);
};

export default usePermission;
